import * as React from 'react';
const isReactInputEvent = (event)=>{
    return !!event && typeof event === 'object' && 'target' in event && 'checked' in event.target;
};
const isStringArray = (value)=>{
    return Array.isArray(value) && value.every((item)=>typeof item === 'string');
};
/**
 * A hook that provides adapter functions for checkbox form integration.
 *
 * Handles both single checkboxes (boolean values) and checkbox groups (array values).
 * For checkbox groups, it manages adding/removing individual values from the form array.
 */ export function useCheckboxFormAdapter() {
    const valueAdapter = React.useCallback((fieldValue, controlValue)=>{
        if (isStringArray(fieldValue)) {
            return typeof controlValue === 'string' && fieldValue.includes(controlValue);
        }
        // For single checkboxes, use the field value directly
        return Boolean(fieldValue);
    }, []);
    const changeAdapter = React.useCallback((event, fieldValue, controlValue)=>{
        if (!isReactInputEvent(event)) {
            return fieldValue;
        }
        const isChecked = event.target.checked;
        if (isStringArray(fieldValue) && typeof controlValue === 'string') {
            if (isChecked) {
                // Add value to array if not already present
                return fieldValue.includes(controlValue) ? fieldValue : [
                    ...fieldValue,
                    controlValue
                ];
            } else {
                // Remove value from array
                return fieldValue.filter((item)=>item !== controlValue);
            }
        }
        // For single checkboxes, return the checked state
        return isChecked;
    }, []);
    return {
        valueAdapter,
        changeAdapter
    };
}

//# sourceMappingURL=useCheckboxFormAdapter.js.map